var map = {
	"./de.json": [
		3850,
		850
	],
	"./en.json": [
		4978
	],
	"./es.json": [
		1537,
		537
	],
	"./fr.json": [
		3417,
		417
	],
	"./it.json": [
		5748,
		748
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2060;
module.exports = webpackAsyncContext;